import { ArrowRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";
import { Thread } from "./Thread";
import { trackEvent } from "../lib/tracking";

// Denver local authority — strong for local SEO without letting the site
// read as local-only. Follows NationalVirtual so the national frame leads.
export const DenverLocal = () => (
  <section id="denver-in-home" data-testid="denver-local-section" className="bg-creamsoft">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-6 lg:pt-10">
      <Thread className="text-clay/40" flip />
    </div>

    <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <Label>Closer to home</Label>
          </Reveal>
          <Reveal as="h2" delay={0.08} className="mt-6 font-serif font-light text-ink text-4xl sm:text-5xl leading-[1.08] tracking-tight">
            In-home pediatric sleep
            <span className="block">consulting in</span>
            <span className="block italic text-clay">Denver.</span>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <div className="space-y-5 max-w-xl text-base sm:text-lg font-normal leading-relaxed text-smoke">
            <p>
              For Denver-area families who want me in the room — bedtime as it
              actually happens, the light in the nursery, the routine in real
              time — selected in-home support is available locally.
            </p>
            <p>
              It&rsquo;s the higher-touch version of the same work. And for
              families everywhere else: virtual is the full service, not a
              lesser one.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-10 max-w-xl border-y border-ink/10 divide-y divide-ink/10">
            <a
              data-testid="denver-local-link"
              href="/denver-sleep-consultant"
              className="group flex items-baseline justify-between gap-6 py-5"
            >
              <span className="text-base sm:text-lg font-normal text-smoke group-hover:text-ink transition-colors duration-300">
                Sleep support in the Denver area
              </span>
              <ArrowRight size={15} aria-hidden="true" className="shrink-0 text-clay/60 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-clay" />
            </a>
            <a
              data-testid="denver-in-home-link"
              href="/denver-in-home-sleep-consultant"
              onClick={() => trackEvent("in_home_service_click", { location: "denver_local" })}
              className="group flex items-baseline justify-between gap-6 py-5"
            >
              <span className="text-base sm:text-lg font-normal text-smoke group-hover:text-ink transition-colors duration-300">
                In-home visits, for Denver families
              </span>
              <ArrowRight size={15} aria-hidden="true" className="shrink-0 text-clay/60 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-clay" />
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
